import { Grid, Typography } from '@mui/material';

type Props = {
    label: string;
}

export const RequiredLabel = ({ label }: Props) => {
    return (
        <Grid container direction="row" spacing={1}>
            <Grid item>
                <Typography>{label}</Typography>
            </Grid>
            <Grid item>
                <Typography color="red">必須</Typography>
            </Grid>
        </Grid>
    )
}
